module.exports = __webpack_public_path__ + "media/img/backgrounds/static-781d99dedc8e029ac8c9e8009afef415.jpg";